import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import BackImg from "../assets/images/backArrow.png";

@inject(
    'packageStore'
)
@observer
export default class ReservationHeader extends Component {
    render() {
        const {
            packageStore: {
                barcode,
                packageInfo
            },
            tab
        } = this.props;

        const backLink = '/package/' + barcode;
        if(!packageInfo) {
            return(
                <Redirect to={'/'} />
            )
        }

        const shopData = packageInfo.shopTemplates;

        return (
            <header className="App-header">
                <Link to={backLink} className="App-back"><img src={BackImg} width="20" alt="뒤로 가기" /></Link>
                <h1 className="App-title">
                    {shopData.shopNm}
                </h1>
                <ul className="App-tab">
                    <li className={'active'}>
                        <button
                            type="button"
                            className="btn-tab mobile"
                        >
                            {tab === 'result' ? '예약조회' : '모바일로 예약하기'}
                        </button>
                    </li>
                </ul>
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ReservationHeader.jsx